// utils/dates/range.js
function parseLocalYMD(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  // ctor con componentes => fecha local
  return new Date(y, m - 1, d);
}

export function dayStart(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function dayEnd(date) {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
}

export function rangeFromIsoStrings(initISO, endISO) {
  const init = dayStart(parseLocalYMD(initISO));
  const end = dayEnd(parseLocalYMD(endISO));
  return { init, end };
}

export function rangeWithOffset(
  initISO,
  endISO,
  startOffsetDays = 0,
  endOffsetDays = 0
) {
  const i = parseLocalYMD(initISO);
  const e = parseLocalYMD(endISO);
  i.setDate(i.getDate() + startOffsetDays);
  e.setDate(e.getDate() + endOffsetDays);
  return { init: dayStart(i), end: dayEnd(e) };
}
